import React from 'react';
import { Spinner, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import shortid from 'shortid';
import { Schedule } from './hooks';
import { Truck } from '../../../components/atoms/icons';

interface Props {
  scheduleList: Schedule[];
  isLoading: boolean;
}

function RenderTableRouteSchedule(props: Props) {
  const { scheduleList, isLoading } = props;
  const classNameHeader = 'color-placeholder fw-bold border-color-stroke border-bottom fw-normal pb-1 fz-14';

  return (
    <div
      className="border border-1 border-color-stroke w-100 mb-4 d-flex flex-column ms-lg-2"
      style={{ borderRadius: '20px' }}
    >
      <div className="d-flex align-items-center justify-content-between pt-4 px-4 px-xl-5">
        <div className="fw-bold fz-14">Upcoming Route Schedule</div>
        <Link
          className="rounded-pill fz-14 color-placeholder px-3 py-1 text-decoration-none"
          style={{ border: '2px solid #AEAEAE' }}
          to="/routes/schedule"
        >
          View All
        </Link>
      </div>
      <div className="flex-grow-1 py-4 flexible-center">
        {scheduleList && scheduleList.length ? (
          <div className="w-100 mt-4 align-self-start">
            <Table borderless responsive>
              <thead>
                <tr>
                  <th className={`${classNameHeader} ps-4 ps-xl-5`}>#</th>
                  <th className={classNameHeader}>NAME</th>
                  <th className={classNameHeader}>DRIVER</th>
                  <th className={`${classNameHeader} pe-4 pe-xl-5`}>SERVICE DAY</th>
                </tr>
              </thead>
              <tbody>
                {scheduleList.map((data, i) => (
                  <tr
                    key={shortid.generate()}
                    className={i % 2 !== 0 ? 'bg-solid align-middle' : 'align-middle'}
                    style={{ height: '50px' }}
                  >
                    <td className="fz-14 ps-4 ps-xl-5">{i + 1}</td>
                    <td className="fz-14">{data.name}</td>
                    <td className="fz-14">{data.driver}</td>
                    <td className="fz-14 pe-4 pe-xl-5">{data.serviceDay}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        ) : (
          <div className="w-100 flexible-center" style={{ minHeight: '200px' }}>
            {isLoading ? <Spinner animation="border" />
              : (
                <div className="flexible-center flex-column">
                  <div
                    className="rounded-circle flexible-center mb-2"
                    style={{ height: 65, width: 65, backgroundColor: '#F2F3F7' }}
                  >
                    <Truck />
                  </div>
                  <div className="fz-14">Routes are not scheduled yet.</div>
                </div>
              )}
          </div>
        )}
      </div>
    </div>
  );
}

export default React.memo(RenderTableRouteSchedule);
